var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetPasswordManagerRulesQuery, useResetPasswordMutation, } from "@/store/api";
import { Input } from "@mui/joy";
import { useTranslation } from "react-i18next";
import { PUBLIC_URL } from "@/utils/const";
import toast from "react-hot-toast";
export default function ResetPasswordPage() {
    var _this = this;
    var _a;
    var t = useTranslation(["common", "Users"]).t;
    var guid = useParams().guid;
    var navigate = useNavigate();
    var _b = useState(""), newPassword = _b[0], setNewPassword = _b[1];
    var _c = useState(""), username = _c[0], setUsername = _c[1];
    var _d = useState(""), confirmPassword = _d[0], setConfirmPassword = _d[1];
    var _e = useState(""), error = _e[0], setError = _e[1];
    var _f = useState(""), errorConfirm = _f[0], setErrorConfirm = _f[1];
    var resetPassword = useResetPasswordMutation()[0];
    var _g = useGetPasswordManagerRulesQuery({}), configData = _g.data, isLoading = _g.isLoading, isFetching = _g.isFetching;
    var settingsPassValue = (_a = configData === null || configData === void 0 ? void 0 : configData.data) === null || _a === void 0 ? void 0 : _a.password;
    var minpwdlength = settingsPassValue === null || settingsPassValue === void 0 ? void 0 : settingsPassValue.minpwdlength;
    var oneupper = (settingsPassValue === null || settingsPassValue === void 0 ? void 0 : settingsPassValue.oneupper) || "";
    var onelower = (settingsPassValue === null || settingsPassValue === void 0 ? void 0 : settingsPassValue.onelower) || "";
    var onenumber = (settingsPassValue === null || settingsPassValue === void 0 ? void 0 : settingsPassValue.onenumber) || "";
    var onespecial = (settingsPassValue === null || settingsPassValue === void 0 ? void 0 : settingsPassValue.onespecial) || "";
    var _h = useState(""), passwordError = _h[0], setPasswordError = _h[1];
    var rules = useMemo(function () {
        if (!settingsPassValue)
            return [];
        var list = [];
        if (oneupper) {
            list.push(t("LBL_PASSWORD_REQUIRE_UPPERCASE", { ns: "Users" }));
        }
        if (onelower) {
            list.push(t("LBL_PASSWORD_REQUIRE_LOWERCASE", { ns: "Users" }));
        }
        if (onenumber) {
            list.push(t("LBL_PASSWORD_REQUIRE_NUMBER", { ns: "Users" }));
        }
        if (onespecial) {
            list.push(t("LBL_PASSWORD_REQUIRE_SPECIAL", { ns: "Users" }));
        }
        if (minpwdlength) {
            list.push(t("LBL_PASSWORD_LENGTH", {
                ns: "Users",
                length: minpwdlength,
            }));
        }
        return list;
    }, [
        settingsPassValue,
        oneupper,
        onelower,
        onenumber,
        onespecial,
        minpwdlength,
        t,
    ]);
    var validatePassword = function (password) {
        if (minpwdlength && password.length < Number(minpwdlength)) {
            return t("LBL_PASSWORD_LENGTH", {
                ns: "Users",
                length: minpwdlength,
            });
        }
        if (oneupper && !/[A-Z]/.test(password)) {
            return t("LBL_PASSWORD_REQUIRE_UPPERCASE", { ns: "Users" });
        }
        if (onelower && !/[a-z]/.test(password)) {
            return t("LBL_PASSWORD_REQUIRE_LOWERCASE", { ns: "Users" });
        }
        if (onenumber && !/[0-9]/.test(password)) {
            return t("LBL_PASSWORD_REQUIRE_NUMBER", { ns: "Users" });
        }
        if (onespecial && !/[!@#$%^&*(),.?\":{}|<>]/.test(password)) {
            return t("LBL_PASSWORD_REQUIRE_SPECIAL", { ns: "Users" });
        }
        return "";
    };
    var handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var passwordValidationError, response, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    e.preventDefault();
                    setError("");
                    setErrorConfirm("");
                    setPasswordError("");
                    passwordValidationError = validatePassword(newPassword);
                    if (newPassword !== confirmPassword) {
                        setErrorConfirm(t("LBL_PASSWORD_MISMATCH", { ns: "Users" }));
                        return [2 /*return*/];
                    }
                    if (passwordValidationError) {
                        setPasswordError(passwordValidationError);
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, resetPassword({
                            body: {
                                guid: guid,
                                username: username,
                                new_password: newPassword,
                            },
                        }).unwrap()];
                case 2:
                    response = _c.sent();
                    if (response.data.success) {
                        toast.success(response.data.message);
                        navigate("/login");
                    }
                    else {
                        setError((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _c.sent();
                    setError((_b = err_1 === null || err_1 === void 0 ? void 0 : err_1.data) === null || _b === void 0 ? void 0 : _b.message);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: "flex justify-center items-center w-full h-full bg-cover bg-[url('https://source.unsplash.com/1600x900/?work')]" }, { children: [_jsx("div", __assign({ className: "flex justify-center text-red-400 absolute top-0" }, { children: error && _jsx("p", { children: error }) })), _jsxs("div", __assign({ className: "w-full relative before:content-[''] before:absolute before:top-0 before:bottom-0 before:w-full before:h-full  before:-z-10 before:rounded-t-md md:w-1/2 xl:w-2/5" }, { children: [_jsx("img", { className: "max-w-[9rem]", src: "".concat(PUBLIC_URL, "/etcrm.png"), alt: "EtCRM" }), _jsxs("div", __assign({ className: "rounded-l-lg before:bg-[color:var(--color-white)] dark:before:bg-[color:var(--color-brand-dark-700)] before:opacity-80 md:before:rounded-t-none md:before:rounded-l-md bg-[var(--colors-background-level1)] " }, { children: [_jsx("div", __assign({ className: "p-4" }, { children: _jsx("h1", { children: t("LBL_RESET_PASSWORD_INSTRUCTION", { ns: "Users" }) }) })), _jsxs("div", __assign({ className: "relative p-5 bg-[var(--colors-background-body)] rounded-r-lg" }, { children: [isLoading || isFetching ? (_jsx("p", __assign({ className: "text-gray-400 italic" }, { children: t("LBL_PASSWORD_RULES_LOADING", { ns: "Users" }) }))) : (rules.length > 0 && (_jsxs("div", __assign({ className: "text-gray-400" }, { children: [_jsx("p", __assign({ className: "italic mb-2" }, { children: t("LBL_PASSWORD_RULES_INTRO", { ns: "Users" }) })), _jsx("ul", { children: rules.map(function (rule, index) { return (_jsxs("li", __assign({ className: "italic" }, { children: ["- ", rule] }), index)); }) })] })))), _jsx("p", __assign({ className: "text-red-500" }, { children: passwordError })), _jsxs("div", __assign({ className: "relative mt-4 rounded-md bg-[color:var(--colors-input-bg)]" }, { children: [_jsx("label", __assign({ className: "pr-4" }, { children: t("LBL_USERNAME", { ns: "Users" }) })), _jsx(Input, { type: "text", value: username, onChange: function (e) { return setUsername(e.target.value); } })] })), _jsxs("div", __assign({ className: "relative mt-4 rounded-md bg-[color:var(--colors-input-bg)]" }, { children: [_jsx("label", __assign({ className: "pr-4" }, { children: t("LBL_NEW_PASSWORD", { ns: "Users" }) })), _jsx(Input, { type: "password", value: newPassword, onChange: function (e) { return setNewPassword(e.target.value); } })] })), _jsxs("div", __assign({ className: "relative mt-4 rounded-md bg-[color:var(--colors-input-bg)]" }, { children: [_jsx("label", __assign({ className: "pr-4" }, { children: t("LBL_CONFIRM_NEW_PASSWORD", { ns: "Users" }) })), errorConfirm && _jsx("p", __assign({ className: "text-red-500" }, { children: errorConfirm })), _jsx(Input, { type: "password", value: confirmPassword, onChange: function (e) { return setConfirmPassword(e.target.value); } })] })), _jsx("div", __assign({ className: "flex flex-row mt-8" }, { children: _jsx("button", __assign({ type: "button", className: "button primary", onClick: handleSubmit }, { children: t("app.LBL_CHANGE_PASSWORD", { ns: "common" }) })) }))] }))] }))] }))] })));
}
